import React from 'react'
import { UIInstagramPostsList } from './types'
import { Column, Row } from '@/components/base/gridview'
import Anchor from '@/components/base/anchor'
import Image from '@/components/base/image'

const InstagramPostsList: React.FC<UIInstagramPostsList> = ({ data = [] }) => {
  return (
    <div className="instagram-posts-list">
      <Row>
        {data.map((item, i) => (
          <Column
            xs={{ size: 4 }}
            sm={{ size: 4 }}
            md={{ size: 4 }}
            lg={{ size: 3 }}
            xl={{ size: 3 }}
            key={i}
          >
            <Anchor className="instagram-posts-list-post" {...item.link}>
              <Image {...item.image} alt={item.title} />
            </Anchor>
          </Column>
        ))}
      </Row>
    </div>
  )
}

export default InstagramPostsList
